const ErrorMessage = ({ message, className = "" }) => {
  if (!message) return null;

  return (
    <div className={`error-message ${className}`} role="alert">
      <span className="error-icon">⚠️</span>
      <span className="error-text">{message}</span>
    </div>
  );
};

export default ErrorMessage;
